const BASE_URL = '/v1/apps';

export const APPS_NUVEMAPPS_URL = `${BASE_URL}/nuvemapps`;
export const APPS_ADMIN_LINKS_URL = `${BASE_URL}/admin-links`;
export const APPS_DETAIL_URL = `${BASE_URL}/:appId`;
export const APPS_TOKEN_URL = `${APPS_DETAIL_URL}/token`;
export const APPS_SCOPES_URL = `${APPS_DETAIL_URL}/scopes`;
export const APPS_AUTHORIZATION_URL = `${APPS_DETAIL_URL}/authorization`;
